import './App.css';
import Main from './main';
import BntAdha9Slots from './modelFunc/components/Button/BntAdha9Slots';
import BntAdha5Slots from './modelFunc/components/Button/BntAdha5Slots';
import { Box } from '@mui/material';
import ModuleCatalog from './ModuleCatalog';
import React, { useEffect, useState } from 'react';
import BntStandaloe from './modelFunc/components/Button/BntStandaloe';
import ReserveNow from './modelFunc/components/Button/ReserveNow';
import { Grid2 } from '@mui/material';
import DownloadDocumentation from './modelFunc/components/Button/DownloadDocumentation';
import { Cego } from './modelFunc/Cego';
import '@fontsource/open-sans';
import logo_orion from './Image/logo_orion.png';
import { Rack9slot } from './modelFunc/Orion_9slotrack';
import { MassMemorySkin } from './modelFunc/Orion_MassMemorySkin';
import { VersaldhuSkin } from './modelFunc/Orion_versaldhuSkin';
import { PowernomSkin } from './modelFunc/Orion_powernomSkin';
import { StdIoSkin } from './modelFunc/Orion_std_io_genericSkin';
import { UsPlusSkin } from './modelFunc/Orion_us_plusSkin';
import { SupervisorSkin } from './modelFunc/Orion_supervisorSkin';
import { ExpBoardSkin } from './modelFunc/Orion_ExpBoardSkin';

const INITIAL_PRICE = 8000;
const INITIAL_DELIVERY_TIME = 4;

/**
 * Calculates the total price of the selected modules.
 * @param {Array} modules - Array of selected modules.
 * @param {number} basePrice - The base price of the configuration.
 * @returns {number} - The total price.
 */
const calculatePrice = (modules, basePrice) => {
  return modules.reduce((acc, mod) => acc + mod.price, basePrice);
};

/**
 * Calculates the estimated delivery time based on the number of selected modules.
 * @param {Array} modules - Array of selected modules.
 * @param {number} baseTime - The base delivery time in months.
 * @returns {number} - The estimated delivery time in months.
 */
const calculateDeliveryTime = (modules, baseTime) => {
  return modules.length > 0 ? Math.round(modules.length * 0.5 + baseTime) : baseTime;
};

/**
 * The main App component that renders the UI for the Orion configuration system.
 * Allows users to select modules, calculate price and delivery time, and trigger actions like downloading documentation or reserving the configuration.
 * @param {Object} props - Component props.
 * @param {Object} props.module - Available modules for selection.
 * @returns {JSX.Element} - The rendered App component.
 */
function App() {
  // State to hold the selected modules
  const [selectedModules, setSelectedModules] = useState([]);
  // State to manage the rack model and its modules
  const [rack9U, setRack9U] = useState({ rackModel: Rack9slot, modules: [] });
  // State for price and delivery time
  const [price, setPrice] = useState(INITIAL_PRICE);
  const [deliveryTime, setDeliveryTime] = useState(INITIAL_DELIVERY_TIME);

  // Effect to update the price whenever selected modules change
  useEffect(() => {
    setPrice(calculatePrice(selectedModules.modules || [], INITIAL_PRICE));
  }, [selectedModules]);

  // Effect to update the delivery time whenever selected modules change
  useEffect(() => {
    setDeliveryTime(calculateDeliveryTime(selectedModules.modules || [], INITIAL_DELIVERY_TIME));
  }, [selectedModules]);


  // Available modules list with their respective properties
  const availableModules = [
    { id: 'massMemory', name: 'Mass Memory', description: 'Provides power to the rack.', Width_HP: 30.5, slot: 3, func: MassMemorySkin, price: 12000 },
    { id: 'powernom', name: 'Power Supply', description: 'Main server unit.', Width_HP: 30.5, slot: 1, func: PowernomSkin, price: 8000 },
    { id: 'stdIO', name: 'Standard I/O', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: StdIoSkin, price: 800 },
    { id: 'versaldhu', name: 'VERSAL Data Handling Computer', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: VersaldhuSkin, price: 30000 },
    { id: 'generic', name: 'Generic Peripheral Board', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: StdIoSkin, price: 8000 },
    { id: 'usPlus', name: 'Ultrascale + Computer', description: 'Main server unit.', Width_HP: 30.5, slot: 6, func: UsPlusSkin, price: 30000 },
    { id: 'supervisor', name: 'Onboard Computer Supervisor', description: 'Main server unit.', Width_HP: 30.5, slot: 4, func: SupervisorSkin, price: 10000 },
    { id: 'expBoard', name: 'Ethernet Expansion Board', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: ExpBoardSkin, price: 8000 },
    { id: 'painelCego', name: 'Painel Cego', description: 'Painel cego', Width_HP: 30.5, slot: 3, func: Cego, price: 0 },
  ];

  return (
    <div className='App'>
      {/* Header section with format options */}
      <Box className="header" sx={{ width: '99%', mb: 0, padding: '12px' }}>
        <Grid2 container justifyContent="center" alignItems="center" spacing={6}>
          <Box className="logo-container" sx={{ display: 'flex', alignItems: 'center' }}>
            <Box className="text-container" sx={{ display: 'flex', flexDirection: 'column', position: 'relative', right: '25%' }}>
              <h2 className="Format">Format</h2>
              <p className="Select">Select One</p>
            </Box>
          </Box>
          <Grid2 item><BntAdha5Slots /></Grid2>
          <Grid2 item><BntAdha9Slots /></Grid2>
          <Grid2 item><BntStandaloe /></Grid2>
          <Grid2> <img className="logo_orion" src={logo_orion} alt="Logo Orion" /></Grid2>
        </Grid2>
      </Box>

      {/* Main layout with module catalog and 3d view */}
      <Grid2 container sx={{ height: '100%', width: '100%' }}>
        <Grid2 item xs={12} md={3} sx={{ height: '100%', width: '25%' }}>
          <Box className="ModuleCatalog" sx={{ height: '100%' }}>
            <ModuleCatalog
              m={availableModules}
              setSelectedModules={setSelectedModules}
              rack9U={rack9U}
              setRack9U={setRack9U}
            />
          </Box>
        </Grid2>

        <Grid2 item xs={12} md={9} sx={{ height: '100%', width: '40%' }}>
          <Box className="Main" sx={{ height: '100%' }}>
            <Main selectedModules={selectedModules} />
          </Box>
        </Grid2>
      </Grid2>

      {/* Footer with price, delivery time, and buttons */}
      <Box
        className="footer"
        sx={{
          position: 'fixed',
          bottom: 0,
          width: '99%',
          background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(20,63,83,1) 50%, rgba(43,140,185,1) 98%)',
          left: '0.25%',
          padding: '1px 5px',
          borderRadius: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.2)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', marginLeft: '5%', fontFamily: 'Open Sans', fontSize: '18px' }}>
          <DownloadDocumentation selectedModules={selectedModules} price={price} deliveryTime={deliveryTime} />
        </div>

        <div style={{ textAlign: 'center', flex: 1 }}>
          <h2 style={{
            margin: 0,
            fontFamily: 'Open Sans',
            fontSize: '18px',
            color: 'white',
            WebkitTextStroke: '0.1px #F8F8F8',
            textShadow: '0px 1px 1px #23430C'
          }}>
            Estimated Price: {price} € <br />
            Estimated delivery time: {deliveryTime} months
          </h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '3%' }}>
          <div style={{ marginRight: '12%', position: 'relative', bottom: '-10px' }}>
            <ReserveNow selectedModules={selectedModules} price={price} deliveryTime={deliveryTime} />
          </div>
          <p style={{ position: 'relative', bottom: '10px', marginRight: '0px', fontFamily: 'Open Sans', fontSize: '16px', color: '#fff' }}>
            For quantity discounts, contact us
          </p>
        </div>
      </Box>
    </div>
  );
}

export default App;
